import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loading from 'react-loading';

import DefaultInput from '../../../components/Input';
import Button from '../../../components/Button';
import Logo from '../../../assets/images/logo-parquearauco.png';
import Icon from '../../../assets/images/logo.png';
import {
  Container,
  Wrapper,
  Title,
  PreTitle,
  IconImg,
  Footer,
  CustomLink
} from '../styles';

import { forgotPassword } from '../../../store/actions/AuthActions';
import { forgotPasswordSchema } from '../constants';

export default function LostPassword() {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [usernameError, setUsernameError] = useState('');

  const loading = useSelector(state => state.auth.loading);

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      submit();
    }
  }

  function handleUsernameOnChange(e) {
    setUsername(e.target.value);
  }

  function handleOnClick() {
    submit();
  }

  async function submit() {
    try {
      setUsernameError(false);

      await forgotPasswordSchema.validate({ username }, { abortEarly: false });

      dispatch(forgotPassword(username));
    } catch (err) {
      if (err.errors) {
        setUsernameError(true);
      }
    }
  }

  return (
    <Container>
      <CustomLink to="/">
        <IconImg src={Logo} />
      </CustomLink>

      <Title>
        <PreTitle>SISTEMAS </PreTitle>AUTENTICACIÓN
      </Title>
      <Wrapper>
        <p>Recuperar contraseña</p>
        <DefaultInput
          error={usernameError}
          label="INGRESE EL USUARIO"
          name="name"
          placeholder="Usuario"
          placeholderColor="#bbb"
          onKeyDown={handleKeyDown}
          onChange={handleUsernameOnChange}
        />
        <Button
          text={
            loading ? <Loading height={15} width={15} type="spin" /> : 'Enviar'
          }
          onClick={handleOnClick}
        />
        <CustomLink to="/">Volver</CustomLink>
      </Wrapper>
      <Footer>
        <IconImg src={Icon} />
      </Footer>
    </Container>
  );
}
